export default class ReoptimizedLineupsViewNotFoundError extends Error {}
